export default __webpack_public_path__ + "static/media/06.0aa56789.jpg";